import resolveExpression from '../simpleScript/expressionParser/resolveExpression';
import { compress, decompress } from 'shrink-string';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
){
    try{
        let {
            functionType='',
            executionObject={}
        } = functionObj;
        let {
            data={}, variableName='', variableUnavailable=false
        } = executionObject;
        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }
        let variableCopy = variableObject;
        let resolvedData = await resolveExpression(
            data,
            variableCopy,
            parameterObject,
            functionMap,
            variableIdMap
        );
        let resolvedValue = resolvedData.value;
        variableCopy = resolvedData.variableObject;
        let parsedValue;
        if(functionType === 'compressString'){
            parsedValue = await compress(resolvedValue);
        }else{
            parsedValue = await decompress(resolvedValue);
        }
        variableCopy[variableName] = parsedValue;
        functionType = null;
        executionObject = null;
        functionObj = null;
        variableObject = null;
        parameterObject = null;
        functionMap = null;
        variableIdMap = null;
        resolvedData = null;
        resolvedValue = null;
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/jsonCsvConverter catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}